import { ISpecialOdd } from '@core/models/specials/SpecialOdd';
import Rule from '@core/models/shared/betSlip/Rule';
import Plain from '@core/utils/types/Plain';

export interface ISpecialMarketEvent {
    betStart: Date;
    betEnd: Date;
    isCurrentlyOffered: () => boolean;
    isAvailableForBetting: () => boolean;
}

abstract class SpecialMarketEventBase implements ISpecialMarketEvent {
    betStart: Date;
    betEnd: Date;

    constructor(data: Plain<SpecialMarketEventIncomplete>) {
        Object.assign(this, data);
    }

    public isCurrentlyOffered() {
        const now = new Date();
        return this.betStart <= now && now < this.betEnd;
    }

    abstract isAvailableForBetting(): boolean;
}

export class SpecialMarketEventIncomplete extends SpecialMarketEventBase {
    public isAvailableForBetting() {
        return this.isCurrentlyOffered();
    }
}

export default class SpecialMarketEvent extends SpecialMarketEventBase {
    id: number;
    code: number;
    name: string;
    betStart: Date;
    betEnd: Date;
    dateTime: Date;
    specialBetValue: string | undefined;
    odds: ISpecialOdd[];
    rules: Rule[];
    fieldDefinitions: string[];

    constructor(data: Plain<SpecialMarketEvent>) {
        super(data);
        Object.assign(this, data);
    }

    public isAvailableForBetting() {
        return this.isCurrentlyOffered() && this.odds.some(odd => !odd.isLocked);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/specials/SpecialMarketEvent.ts